<template>
	<div>
		<h2>
			{{ $t('form-library-item') }}
			<div class="float-right">
				<button @click="save" class="btn btn-primary">{{ $t('save') }}</button>
			</div>
		</h2>

		<div v-if="saved">
			<div class="alert alert-success mt-8">{{ $t('saved') }}</div>
		</div>

		<template v-if="item">
			<div class="form-group">
				<label for="item-title">{{ $t('title') }}</label>
				<input id="item-title" name="itemtitle" class="form-control" v-model="item.title" :placeholder="$t('title')" required>
			</div>

			<div class="form-group">
				<label for="item-notes">{{ $t('notes') }}</label>
				<input id="item-notes" name="itemnotes" class="form-control" v-model="item.notes" :placeholder="$t('notes')" required>
			</div>
		</template>

		<FieldEditor :editing="item.json" ref="fieldeditor" :permissions="permissions" v-show="(item_type == 'field')"></FieldEditor>
		<OptionsEditor v-if="(item_type == 'selectoptions')" :options="item.json"></OptionsEditor>

    </div>
</template>

<script>
import FieldEditor from "src/components/FormEditor/FieldEditor";
import OptionsEditor from "src/components/FormEditor/OptionsEditor";
export default {
	components: {
		FieldEditor,
		OptionsEditor
	},
    data: function() {
        return {
        	item_id: null,
        	item_type: null,
        	item: {
        		json: null
        	},
        	saved: false,
			permissions: [
				{
					value: 'student',
					text: this.$t('student')
				},
				{
					value: 'teacher',
					text: this.$t('teacher')
				},
				{
					value: 'all',
					text: this.$t('all')
				},
			]
        }
    },
    methods: {
    	save() {

        	const data = {
        		settings: this.item.json,
        		title: this.item.title,
        		type: this.item_type,
        		notes: this.item.notes,
			}

			if(this.item_id) {
				data.item_id = this.item_id;
			}

  			this.$cfetch(`${this.$settings.APIBaseURL}/formlibrary/save`, {
  				method: 'post',
  				data
  			})
			.then(json => {
				if (json.status == 'SUCCESS') {
					this.item_id = json.item.id;
					this.saved = true;
					setTimeout(() => {
						this.saved = false;
					}, 5000);
				}
			}).catch(error => {
				this.$log.error.call(this, error);
			});
    	},
    	getItem(id) {
  			this.$cfetch(`${this.$settings.APIBaseURL}/formlibrary/getitem/${id}`)
			.then(json => {
				this.$store.commit("hideBlockingSpinner");
				if (json.status == 'SUCCESS') {

					this.item = json.item;
					if(this.item.type == 'field') {
						this.$refs.fieldeditor.patchField(this.item.json);
					}
					this.item_id = this.item.id;
					this.item_type = this.item.type;

				}
			}).catch(error => {
				this.$log.error.call(this, error);
				this.$store.commit("hideBlockingSpinner");
				this.$log.error.call(this, error);
			});
    	},
    },
    computed: {
    },
    mounted() {

    	if(this.$route.params.itemid) {
    		this.getItem(this.$route.params.itemid)
    	} else {
    		this.item_type = this.$route.query.type;
    		if(this.item_type == 'field') {
    			this.item.json = this.$refs.fieldeditor.getDefaultField();
    		} else if(this.item_type == 'selectoptions') {
    			this.item.json = [];
    		}
    		this.$store.commit("hideBlockingSpinner");
    	}
    }
}
</script>
